; (function ($, window, document, undefined) {
    'use strict';
    // nom de librairie à modifier
    Foundation.libs.giftcard = {
        name: 'giftcard',

        version: '1.0.0',

        settings: {
            callback: function () { }
        },
        init: function (scope, method, options) {
            // initialisation à conserver
            Foundation.inherit(this, '');
            var self = this;

            // à conserver
            this.bindings(method, options);
        },
        events: function () {
            var self = this;
            var S = this.S;
            $(this.scope)
                .ready(function (event) {
                })
                // CHOIX PRIX - DESKTOP & MOBILE
                .on("click", ".bt-price-choice", function (e) {
                    var product = $(this).attr('data-product-reference');
                    var price = $(this).attr('data-price');
                    var tooltip = $("#" + $(this).attr('data-selector'));
                    $.ajax({
                        url: '/ProductAction/SetPrice',
                        data: {
                            productId: product,
                            price: price
                        },
                        success: function (result) {
                            if (result.IsValid) {
                                $("#product-informations").html(result._Informations);

                                $(".final-price").html(result.selectedPrice);
                            }

                            // Réinit lazyload pour les cartes en crossSel
                            LazyLoad.reset();
                        },
                        beforeSend: function () {
                            $(document).foundation('common', 'showPreloader');
                        },
                        complete: function () {
                            $(document).foundation('common', 'hidePreloader');
                        },
                        cache: false
                    });
                })
                // CLIC MESSAGE CARTE CADEAU ou BOUTON ANNULER
                .on('click', '.giftCardMessage, #btn-giftcard-message-cancel', function (event) {
                    event.preventDefault();

                    if ($(".giftCardMessage.closed")[0]) {
                        $(".giftCardMessage").removeClass("closed");
                    } else {
                        $(".giftCardMessage").addClass("closed");
                    }

                    if ($("#giftcard-massage-wrapper").css('display') === 'none') {
                        $("#giftcard-massage-wrapper").show();
                    }
                    else {
                        $("#giftcard-massage-wrapper").hide();
                    }
                })
                // CLIC MESSAGE CARTE CADEAU SUPPRIMER
                .on('click', '#btn-giftcard-message-delete', function (event) {
                    event.preventDefault();

                    var product = $(this).attr('data-product-reference');

                    $.ajax({
                        type: "POST",
                        url: '/ProductAction/DeleteGiftCardMessage',
                        data: {
                            productId: product,
                        },
                        success: function (result) {
                            if (result.IsValid) {
                                $("#product-informations").html(result._ProductInformations);
                            }
                        },
                        beforeSend: function () {
                            $(document).foundation('common', 'showPreloader');
                        },
                        complete: function () {
                            $(document).foundation('common', 'hidePreloader');
                        },
                        cache: false
                    });
                })
                // CLIC MESSAGE CARTE CADEAU MODIFIER
                .on('click', '#btn-giftcard-message-edit', function (event) {
                    event.preventDefault();

                    var product = $(this).attr('data-product-reference');

                    $.ajax({
                        type: "POST",
                        url: '/ProductAction/EditGiftCardMessage',
                        data: {
                            productId: product,
                        },
                        success: function (result) {
                            if (result.IsValid) {
                                $("#giftcard-massage-wrapper").html(result._GiftMessage);
                            }
                        },
                        beforeSend: function () {
                            $(document).foundation('common', 'showPreloader');
                        },
                        complete: function () {
                            $(document).foundation('common', 'hidePreloader');
                        },
                        cache: false
                    });
                })
                // CLIC MESSAGE CARTE CADEAU SUPPRIMER DEPUIS PANIER
                .on('click', '#btn-giftcard-message-deletefromcart', function (event) {
                    event.preventDefault();

                    var product = $(this).attr('data-product-reference');
                    var itemId = $(this).attr('data-line-id');

                    $.ajax({
                        type: "POST",
                        url: '/ProductAction/DeleteGiftCardMessageFromCart',
                        data: {
                            productId: product,
                            itemId: itemId
                        },
                        success: function (result) {
                            if (result.IsValid) {
                                Foundation.libs.common.showPreloader();

                                window.location = result.RedirectionUrl;
                            }
                        },
                        beforeSend: function () {
                            $(document).foundation('common', 'showPreloader');
                        },
                        error: function () {
                            $(document).foundation('common', 'hidePreloader');
                        },
                        cache: false
                    });
                })
        },
        OnSuccessAddGiftCardMessage: function (result) {
            if (result.IsValid) {
                $("#product-informations").html(result._ProductInformations);
            }
            else {
                $("#giftcard-massage-wrapper").html(result._GiftMessage);
            }

            // Réinit lazyload pour les cartes en crossSel
            LazyLoad.reset();

            Foundation.libs.common.hidePreloader();
        },

        OnSuccessAddGiftCardMessageFromCart: function (result) {
            if (result.IsValid) {
                Foundation.libs.common.showPreloader();

                window.location = result.RedirectionUrl;
            }
            else {
                $("#giftcard-massage-wrapper").html(result._GiftMessage);
            }
        }
    };
}(jQuery, window, window.document));